import React, { useEffect, useState } from 'react';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink,Image } from '@react-pdf/renderer';
import { Button, HStack, Input, VStack } from '@chakra-ui/react';
import sls from '../images/sls.png'
import axios from 'axios';
import { backendurl } from '../path';
// Create styles
const styles = StyleSheet.create({
    container: {
      padding: 20,
    },
    header: {
      textAlign: 'center',
      fontSize: 24,
      display:'inline=block'
    },
    logo: {
      width: 120,
      height: 120,
      alignSelf: 'center',
    },
    address: {
      marginBottom: 20,
      paddingBottom:4,
    },
    fieldsContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      marginBottom: "20px",
    },
    photos:{
        marginTop: "25px",
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderTop:'1px solid gray',
        paddingTop:'10px'
    },
    photo:{
      width: 100,
      height: 100,
      border:'1px solid gray',
      fontSize:'10px',
      padding: '10px',
    },
   
    inner:{
        flexDirection: 'row',
    },
    topcont:{
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom:'1px solid gray',
        marginBottom:'10px',
    },
    fieldLabel: {
      fontWeight: 'bold',
      marginRight:20,
      fontSize:"12px"
    },
    fielddata:{
        fontWeight:'hairline',
        fontSize:"10px",
    },
    bottom:{
      flexDirection: 'row',
        justifyContent: 'space-between',
       marginTop:'30px',
    }
   
  });
  
// Create PDF component
const MyDocument = ({data}) => (
    <Document>
    <Page size="A4">
      <View style={styles.container}>
      <View style={styles.topcont}>
        <Text style={styles.header}>Admission Form</Text>
        <Image src={sls} style={styles.logo} />
        <View style={styles.address}>
          <Text>S.L.S Memorial Public School</Text>
          <Text>budina kalan, muzaffarnagar</Text>
          <Text>uttar pradesh, india</Text>
        </View>

        </View>
        

       

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
          <Text style={styles.fieldLabel}>Date:</Text>
          <Text style={styles.fielddata}>{data.date}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Admission No:</Text>
          <Text style={styles.fielddata}>{data.adm}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Registar No:</Text>
          <Text style={styles.fielddata}>{data.reg}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Student Name:</Text>
          <Text style={styles.fielddata}>{data.studentname}</Text>
            </View>

            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Aadhar No:</Text>
          <Text style={styles.fielddata}>{data.stadh}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Mother's Name:</Text>
          <Text style={styles.fielddata}>{data.mname}</Text>
            </View>

            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Aadhar No:</Text>
          <Text style={styles.fielddata}>{data.madh}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Father's Name:</Text>
          <Text style={styles.fielddata}>{data.fname}</Text>
            </View>

            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Aadhar No:</Text>
          <Text style={styles.fielddata}>{data.fadh}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Permanent Address:</Text>
          <Text style={styles.fielddata}>{data.address}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Phone No:</Text>
          <Text style={styles.fielddata}>{data.phone}</Text>
            </View>
        </View>
        
        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Guardian Occupation:</Text>
          <Text style={styles.fielddata}>{data.occupation}</Text>
            </View>
        </View>


        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Category:</Text>
          <Text style={styles.fielddata}>{data.category}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Class:</Text>
          <Text style={styles.fielddata}>{data.Class}</Text>
            </View>
        </View>
        
        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Date of Birth:</Text>
          <Text style={styles.fielddata}>{data.dob}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Previous School Name:</Text>
          <Text style={styles.fielddata}>{data.exschool}</Text>
            </View>
            <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Previous Class:</Text>
          <Text style={styles.fielddata}>{data.exclass}</Text>
            </View>
        </View>

        <View style={styles.fieldsContainer}>
        <View style={styles.inner}>
            <Text style={styles.fieldLabel}>Withdrawal:</Text>
          <Text style={styles.fielddata}>{data.wid}</Text>
            </View>
        </View>

        <View style={styles.photos}>
        <Image src={data.imageUrl1} style={styles.logo} />
        <Image src={data.imageUrl2} style={styles.logo} />
        <Image src={data.imageUrl3} style={styles.logo} />
        </View>


        <View style={styles.bottom}>
        <Text style={styles.fielddata}>Date</Text>
        <Text style={styles.fielddata}>Signature of Parents</Text>
        <Text style={styles.fielddata}>Signature of Head of School</Text>
        </View>
    
      </View>
    </Page>
  </Document>
);


const Admission = ()=>{

    const [date,setdate] = useState(null);
    const [adm,setadm] = useState(null);
    const [reg,setreg] = useState(null);
    const [studentname,setsname] = useState(null);
    const [stadh,setstadh] = useState(null);
    const [mname,setmname] = useState(null);
    const [madh,setmadh] = useState(null);
    const [fname,setfname] = useState(null);
    const [fadh,setfadh] = useState(null);
    const [address,setadd] = useState(null);
    const [occupation,setoccu] = useState(null);
    const [category,setcat] = useState(null);
    const [dob,setdob] = useState(null);
    const [exschool,setexschool] = useState(null);
    const [exclass,setexclass] = useState(null);
    const [wid,setwid] = useState(null);
    const [Class,setclass] = useState(null);
    const [phone,setphone] = useState(null);

    const [imageUrl1, setImageUrl1] = useState(null);
    const [imageUrl2, setImageUrl2] = useState(null);
    const [imageUrl3, setImageUrl3] = useState(null);
  

    const receiptData = {
        date,
        adm,
        reg,
        studentname,
        stadh,
        mname,
        madh,
        fname,
        fadh,
        address,
        occupation,
        category,
        Class,
        dob,
        exschool,
        exclass,
        wid,
        phone,
        imageUrl1,
        imageUrl2,
        imageUrl3

      };

const handlesave = async()=>{
const response =await axios.post(`${backendurl}/insert-student`,{"name":studentname,"classname":Class,"address":address,"mothername":mname,"fathername":fname,"phone":phone,"simg":imageUrl1,"fimg":imageUrl2,"mimg":imageUrl3});
if(response.data.isInserted)
{
  window.alert('inserted');
}

}




const handleImageChange1 = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const imageUrl = e.target.result;
      setImageUrl1(imageUrl);
    };
    reader.readAsDataURL(file);
  }
};

const selectImage1 = () => {
  document.getElementById('imageInput1').click();
};


const handleImageChange2 = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const imageUrl = e.target.result;
      setImageUrl2(imageUrl);
    };
    reader.readAsDataURL(file);
  }
};

const selectImage2 = () => {
  document.getElementById('imageInput2').click();
};

const handleImageChange3 = (event) => {
  const file = event.target.files[0];
  if (file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      const imageUrl = e.target.result;
      setImageUrl3(imageUrl);
    };
    reader.readAsDataURL(file);
  }
};

const selectImage3 = () => {
  document.getElementById('imageInput3').click();
};


    return (
        <VStack mt={'25vh'}>
            <VStack w={['90%','50%']}>
      <HStack w={'full'} >
         <Input type='date' value={date} onChange={(e)=>setdate(e.target.value)}/>     
       <Input type='text' placeholder='Admission No' value={adm} onChange={(e)=>setadm(e.target.value)}/>     
       <Input type='text' placeholder='Registor No' value={reg} onChange={(e)=>setreg(e.target.value)}/>     
        </HStack>
        <HStack w={'full'} >
       <Input type='text' placeholder='student name' value={studentname} onChange={(e)=>setsname(e.target.value)}/>     
         <Input type='text' value={stadh} placeholder="Student Aadhar" onChange={(e)=>setstadh(e.target.value)}/>        
        </HStack>

        <HStack w={'full'} >
       <Input type='text' placeholder='mother name' value={mname} onChange={(e)=>setmname(e.target.value)}/>     
         <Input type='text' value={madh} placeholder="mother Aadhar" onChange={(e)=>setmadh(e.target.value)}/>        
        </HStack>
    
        <HStack w={'full'} >
       <Input type='text' placeholder='father name' value={fname} onChange={(e)=>setfname(e.target.value)}/>     
         <Input type='text' value={fadh} placeholder="father Aadhar" onChange={(e)=>setfadh(e.target.value)}/>        
        </HStack>

        <HStack w={'full'} >
         <Input type='text' placeholder='address' value={address} onChange={(e)=>setadd(e.target.value)}/>     
       <Input type='text' placeholder='Guradian Occupation' value={occupation} onChange={(e)=>setoccu(e.target.value)}/>     
       <Input type='text' placeholder='ST/SC/OBC/GENERAL' value={category} onChange={(e)=>setcat(e.target.value)}/>     
        </HStack>

        <HStack w={'full'} >
        <HStack w='50%'>
      <Text>Date of Birth</Text>
        <Input type='date'  value={dob} onChange={(e)=>setdob(e.target.value)}/>     
      </HStack> 
      <HStack>
      <Input type='text' placeholder='class' value={Class} onChange={(e)=>setclass(e.target.value)}/>     
         <Input type='text' placeholder='phone number' value={phone} onChange={(e)=>setphone(e.target.value)}/>     
      </HStack>
   
        </HStack>

        <HStack w={'full'} >
        <Input type='text' placeholder='Previous school name' value={exschool} onChange={(e)=>setexschool(e.target.value)}/>     
       <Input type='text' placeholder='Previous class' value={exclass} onChange={(e)=>setexclass(e.target.value)}/>     
       <Input type='text' placeholder='Withdrawl' value={wid} onChange={(e)=>setwid(e.target.value)}/>     
        </HStack>
        <HStack>
        <VStack spacing={4}>
      <Input
        type="file"
        id="imageInput1"
        accept="image/*"
        display="none"
        onChange={handleImageChange1}
        />
      <Button onClick={selectImage1}>Select student image</Button>
      {imageUrl1 && <img src={imageUrl1} alt="studentphoto" style={{height:'60px',width:'60px'}}/>}
    </VStack>

    <VStack spacing={4}>
      <Input
        type="file"
        id="imageInput2"
        accept="image/*"
        display="none"
        onChange={handleImageChange2}
        />
      <Button onClick={selectImage2}>Select father image</Button>
      {imageUrl2 && <img src={imageUrl2} alt="studentphoto" style={{height:'60px',width:'60px'}}/>}
    </VStack>


    <VStack spacing={4}>
      <Input
        type="file"
        id="imageInput3"
        accept="image/*"
        display="none"
        onChange={handleImageChange3}
        />
      <Button onClick={selectImage3}>Select mother image</Button>
      {imageUrl3 && <img src={imageUrl3} alt="studentphoto" style={{height:'60px',width:'60px'}}/>}
    </VStack>

        </HStack>

            </VStack>
       

        <Button colorScheme='orange' variant={'solid'} mb={8} onClick={handlesave}>
        <PDFDownloadLink document={<MyDocument data={receiptData} />} fileName="Registration.pdf">
          {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Download PDF')}
        </PDFDownloadLink>
        </Button>
      </VStack>  
    )
}

export default Admission;
